import { useSyncExternalStore } from "react";

export function createPreviewOverride<
    T extends string | number | boolean | null,
>({
    param,
    key,
    parse,
}: {
    param: string;
    key: string;
    parse: (value: string | null) => T | null;
}) {
    const rememberFromUrl = () => {
        if (typeof window === "undefined") return;
        try {
            const value = new URLSearchParams(window.location.search).get(
                param,
            );
            if (value === "auto") window.localStorage.removeItem(key);
            else if (value !== null && parse(value) !== null)
                window.localStorage.setItem(key, value);
        } catch {}
    };
    rememberFromUrl();

    const read = (): T | null => {
        try {
            return parse(window.localStorage.getItem(key));
        } catch {
            return null;
        }
    };

    return function usePreviewOverride(): T | null {
        return useSyncExternalStore(
            (listener) => {
                rememberFromUrl();
                window.addEventListener("storage", listener);
                return () => window.removeEventListener("storage", listener);
            },
            read,
            () => null,
        );
    };
}
